import { computed } from "vue";
import getMenu from "@/router/menu";
import { featuresMap, featuresLoadedAt } from "@/state/api/featuresState";

/**
 * Navigation items recomputés à chaque changement de la map des features.
 *
 * On lit explicitement `featuresMap` et `featuresLoadedAt` ici pour que Vue
 * détecte les dépendances et regénère la liste à chaque toggle (admin UI
 * ou broadcast Reverb `FeatureToggled`). Le filtrage final par clé est
 * effectué dans MenuLink / SubMenuLink via `isFeatureKeyOn`.
 *
 * Le système legacy `ENABLE_*` (ancienne map `enterpriseFeatures` côté
 * userState) a été retiré ; cette source n'est plus consultée.
 */
const navigations: any = computed(() => {
	// Le `void` empêche TS de râler — la lecture suffit à Vue pour tracker.
	void featuresMap.value;
	void featuresLoadedAt.value;
	return getMenu();
});

export default { navigations };
